import { select } from '@redux-saga/core/effects'
import { call, PutEffect } from 'redux-saga/effects'
import type { RootState } from 'state/store'

import api from '../../../../../api/_legacy'
import { TENANT_ID } from '../../../constants'

export function closeAccountSaga(onSuccess: PutEffect, onFail: (e: any) => PutEffect) {
  return function* closeTradeSaga() {
    const state: RootState = yield select()
    const { builder } = state
    const { accountId } = builder

    if (!accountId) {
      throw new Error('FATAL ERROR: accountId has not been set')
    }

    try {
      yield call(api.tenant.closeCreate, accountId, TENANT_ID)

      yield onSuccess
    } catch (error) {
      yield onFail(error)
    }
  }
}

export function closeAllAccountsSaga(onSuccess: PutEffect, onFail: (e: any) => PutEffect) {
  return function* closeAllTradesSaga() {
    const state: RootState = yield select()
    const { builder } = state
    const { note } = builder
    const { noteId } = note

    if (!noteId) {
      throw new Error('FATAL ERROR: noteId has not been set')
    }

    try {
      yield call(api.tenant.closeDetail, noteId, TENANT_ID)

      yield onSuccess
    } catch (error) {
      yield onFail(error)
    }
  }
}
